angular.module('am4')
.controller('loginController', function($scope, UserService, $state, $location, $stateParams, $log) {
    var that = this;

    that.credentials = {};

    // After forgot password reset, prefill this field
    that.credentials.email = $stateParams.email;

    // prevent annoying email validation alert when
    // in the middle of typing an email -- wait until
    // the user has left the field
    that.emailModelOptions = {
        updateOn: 'blur',
        debounce: {
            blur: 0
        }
    };

    // reset password validity upon touching
    $scope.$watch(function() {
        return that.credentials.password;
    }, function() {
        $scope.loginForm.password.$setValidity('password', true);
    });

    that.login = function() {
        that.loginLoading = true;

        UserService.login(that.credentials.email, that.credentials.password)
        .then(function() {
            $location.path($stateParams.then || '/')
            .replace()
            .search('then', null);
        })
        .catch(function() {
            $log.error('Failed logging user in with email ' + that.credentials.email);

            $scope.loginForm.password.$setValidity('password', false);
        })
        .finally(function() {
            that.loginLoading = false;
        });
    };
});



// WEBPACK FOOTER //
// ./src/app/controllers/login.js